import React, { Component } from 'react'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import URI from 'urijs'
import LoginForm from '@app/components/Landing/LoginForm'
import * as sessionActions from '@app/actions/session'
import { afterSignInRedirect } from '@app/helpers/sessionHelper'

class LoginFormContainer extends Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fetching && !this.props.fetching) {
      if (!this.props.error) {
        let { user, history } = this.props
        afterSignInRedirect(user, history)
      }
    }
  }

  handleSubmit(payload) {
    // this.props.boundActions.login(payload)
  }

  render() {
    const { fetching, error, prefix } = this.props

    return (
      <LoginForm
        prefix={prefix}
        user={ URI(window.location.href).query(true) }
        error={error}
        submitting={fetching}
        onSubmit={this.handleSubmit} />
    )
  }
}

const mapStateToProps = (state) => {
  const { session: { user, fetching, error, oauth } } = state
  return { fetching, error, user, oauth }
}

const mapDispatchToProps = (dispatch) => {
  return { boundActions: bindActionCreators(sessionActions, dispatch) }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(LoginFormContainer)
